import { OnInit, ElementRef, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SnackbarService } from 'app/services/snackbar.service';
import { DocumentsService } from 'modules/core/services/documents.service';
import { CustomerDocumentListComponent } from '../customer-document-list/customer-document-list.component';
var CustomerDocumentComponent = /** @class */ (function () {
    function CustomerDocumentComponent(documentsService, cdRef, snackBar) {
        this.documentsService = documentsService;
        this.cdRef = cdRef;
        this.snackBar = snackBar;
        this.unsubscribe$ = new ReplaySubject(1);
        this.loading = false;
    }
    Object.defineProperty(CustomerDocumentComponent.prototype, "record", {
        get: function () {
            return this._record;
        },
        set: function (record) {
            if (!record) {
                return;
            }
            this._record = record;
            this.loadDocumentsTypes(record);
            this.loadAuthenticities();
        },
        enumerable: true,
        configurable: true
    });
    CustomerDocumentComponent.prototype.ngOnInit = function () {
    };
    /**
    * Loads list of documents types
    * @method loadDocumentsTypes
    */
    CustomerDocumentComponent.prototype.loadDocumentsTypes = function (record) {
        var _this = this;
        this.documentsService
            .getDocumentTypes(record.recordType)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(function (res) {
            _this.documentTypes = res;
            _this.cdRef.detectChanges();
        }, function (error) {
            _this.snackBar.error('Error: Failed to load list of document types');
            _this.documentTypes = [];
            _this.cdRef.detectChanges();
        });
    };
    /**
     * Loads list of authenticites for documents
     * @method loadAuthenticities
     */
    CustomerDocumentComponent.prototype.loadAuthenticities = function () {
        var _this = this;
        this.documentsService
            .getAuthenticites()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(function (res) {
            _this.authenticites = res;
            _this.cdRef.detectChanges();
        }, function (error) {
            _this.snackBar.error('Error: Failed to load list of authenticities');
            _this.authenticites = [];
            _this.cdRef.detectChanges();
        });
    };
    /**
     * Handler for edit document event from customer documents list
     * @method editDocumentHandler
     */
    CustomerDocumentComponent.prototype.editDocumentHandler = function (customerDocument) {
        if (customerDocument) {
            this.currentEditCustomerDocument = customerDocument;
            this.isShowDocumentUpdate = true;
        }
        else if (customerDocument === null) {
            this.currentEditCustomerDocument = {
                authenticity: '',
                file: null,
                docName: '',
                backDocName: '',
                docType: null,
                expiryDate: '',
                issueDate: '',
                recordId: this.record.id,
                showExpiryAlerts: true
            };
            this.isShowDocumentUpdate = true;
        }
        else {
            this.currentEditCustomerDocument = null;
            this.isShowDocumentUpdate = false;
        }
        this.cdRef.detectChanges();
        if (this.isShowDocumentUpdate) {
            this.uploadForm.nativeElement.scrollIntoView({ behavior: 'smooth' });
        }
    };
    /**
     * Handler for the save button in update documents card
     * @method documentUpdated
     */
    CustomerDocumentComponent.prototype.documentUpdated = function (data) {
        if (data.error) {
            this.snackBar.error(data.error);
        }
        else {
            this.customerDocumentListComponent.customerDocumentsDataSource.loadDocuments({
                sort: '-updated_at',
                offset: 0
            });
            if (data.mode === 'CREATE') {
                this.snackBar.success('Document successfully uploaded');
            }
            else {
                this.snackBar.success('Document successfully updated');
            }
            this.currentEditCustomerDocument = null;
            this.isShowDocumentUpdate = false;
        }
    };
    // Set loading
    CustomerDocumentComponent.prototype.setLoading = function (loading) {
        this.loading = loading;
        this.cdRef.detectChanges();
    };
    CustomerDocumentComponent.prototype.ngOnDestroy = function () {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    };
    return CustomerDocumentComponent;
}());
export { CustomerDocumentComponent };
